export default {"src":"/_next/static/media/ilu-dare-creator.c6054003.svg","height":203,"width":246};